import type { SxProps, Theme } from "@mui/material";

export const recentlyViewedListItemButtonSx: SxProps<Theme> = {
  appearance: "none",
  boxSizing: "border-box",
  width: "100%",
  margin: 0,
  border: 0,
  borderRadius: 0,
  borderBottom: 1,
  borderColor: "divider",
  backgroundColor: "transparent",
  font: "inherit",
  color: "inherit",
  textAlign: "start",
  textDecoration: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "flex-start",
  gap: 0.75,
  py: 1.5,
  px: 2,
  "&:hover": {
    backgroundColor: "action.hover",
  },
};
